import React, { Component } from "react";
import BsyTurnPage from "../BsyTurnPage";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyAlertListDetail from '../BsyAlertListDetail'
import UserViewDetailCont from './UserViewDetailCont'
import BsyDialog from "../BsyDialog";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyDateTime from "../BsyDateTime";
import OperationRecord from "./OperationRecord";
import BsyAlert from "../BsyAlert";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsySLoading from "../BsySLoading";
import { BsyUtils } from '../../utils/Utils';
import { dayjsUtils } from '../../utils/dayjsUtils';

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      count: 0,
      limit: 20,
      selectVal: props.data || {},
      keyword: "",
      header: [
        {
          name: React.language("order.operation"),
          id: "operation",
          customStyle: "rightLine"
        }, {
          name: React.language("project.site"),
          id: "site",
        }, {
          name: React.language("project.user.account"),
          id: "account",
        }, {
          name: React.language("project.user.name"),
          id: "name",
        }, {
          name: React.language("maturity.time"),
          id: "expire",
        }, {
          name: React.language("current.version"),
          id: "version",
        }, {
          name: React.language("contact.note"),
          id: "note",
        }, {
          name: React.language("state"),
          id: "state",
        }
      ],
      data: [],
      isLoading: true,
    }
  }

  componentDidMount() {
    this.loadData();
    this.props.getContext(this);
  }

  loadData = () => {
    const { skip, limit, selectVal, keyword } = this.state;
    this.setState({ isLoading: true }, () => {
      React.axios("/dashboard/standard_user_list", {
        keyword: keyword,
        _id: selectVal._id,
        skip: skip * limit,
        limit
      }).then(res => {
        const { list, count } = res.data;
        this.setState({ data: list, count, isLoading: false })
      })
    })
  }

  skipChange = (e) => {
    this.setState({
      skip: e
    }, () => {
      this.loadData();
    })
  }

  listLimitChange = (e) => {
    this.setState({
      limit: e,
      skip: 0
    }, () => {
      this.loadData();
    })
  }

  getTimeContext = (e) => {
    this.timeDate = e;
  }

  switchChange = (e) => {

  }

  addProjectDesc = ""

  addChangeProjectDesc = (e) => {
    this.addProjectDesc = e.target.value.replace(/[\r\n]/g, '');
    e.target.value = this.addProjectDesc;
  }

  openOperationMenu = (t) => {
    return (event) => {
      event.stopPropagation();
      const e = event.currentTarget;
      const menu = [
        {
          text: React.language('view.detail'),
          click: () => {
            BsyAlertListDetail({
              type: "custom",
              width: 1000,
              createContent: (e) => {
                return <UserViewDetailCont selectVal={this.state.selectVal} userManagementContext={this} projectId={this.state.selectVal._id} data={t} onRemoveRoot={e.props && e.props.onRemoveRoot} />
              }
            })
          }
        }, {
          text: React.language('postpone'),
          click: () => {
            BsyDialog({
              title: React.language('user.postpone'),
              height: 490,
              width: 460,
              okText: React.language("save"),
              cancelText: React.language("cancel"),
              onContentCreate: () => {
                return <div className={"addProjectContent"}>
                  <div className="addItem name">
                    <div className="itemTitle">
                      <span>{React.language('postpone.time')}</span>
                    </div>
                    <div className="itemValue">
                      <BsyDateTime
                        key={"BsyDateTimeLimit" + new Date().getTime()}
                        width={'100%'}
                        height={36}
                        value={t.expireTime ? new Date(t.expireTime).getTime() : null}
                        theme={this.props.theme}
                        format={'yyyy-MM-dd HH:mm:ss'}
                        width4number={'auto'}
                        waterMark={React.language("placeholder.postpone.time")}
                        onStopEdit={e1 => {
                          this.maturityTime = this.timeDate.state.value;
                        }}
                        getContext={this.getTimeContext}
                      />
                    </div>
                  </div>
                  <div className="addItem remark">
                    <div className="itemTitle">
                      <span>{React.language('postpone.note')}</span>
                    </div>
                    <div className="itemValue">
                      <textarea maxLength={1024} onChange={this.addChangeProjectDesc}
                        placeholder={React.language("placeholder.postpone.note")} />
                    </div>
                  </div>
                </div>
              },
              onOk: () => {
                React.axios("/dashboard/standard_user_update", { _id: this.state.selectVal._id, data_id: t.data_id, expireRemark: this.addPostponeDesc, expireTime: this.maturityTime ? this.maturityTime / 1000 : "" }).then((res) => {
                  if (res.data.code === 200) {
                    tipAlert({
                      type: "success",
                      msg: React.language("update.success")
                    })
                  }

                  this.loadData();
                })
              }
            })
          }
        }, {
          text: t.status === "5" ? React.language("restore") : React.language("disable"),
          color: t.status === "5" ? "" : "var(--bsy-base-error-color)",
          click: () => {
            BsyAlert({
              title: t.status === "5" ? React.language("query.restore.title", { name: t.username }) : React.language("query.disable.title", { name: t.username }),
              // msg: t.status === "5" ? "" : React.language("query.disable.msg"),
              type: "query",
              iconColor: t.status === "5" ? "#0265ff" : "var(--bsy-base-error-color)",
              text4Ok: React.language("ok"),
              OkType: t.status === "5" ? "blue" : "pureRed",
              text4Cancel: React.language("cancel"),
              ok: () => {
                let d = {};
                if (t.status === "5") {
                  d = { _id: this.state.selectVal._id, data_id: t.data_id, restore: true }
                } else {
                  d = { _id: this.state.selectVal._id, data_id: t.data_id, forbid: true }
                }
                React.axios("/dashboard/standard_user_update", d).then((res) => {
                  if (res.data.code === 200) {
                    tipAlert({
                      type: "success",
                      msg: React.language("update.success")
                    })
                  }

                  this.loadData();
                })
              }
            })
          }
        },
        {
          text: React.language('unbind'),
          color: "var(--bsy-base-error-color)",
          click: () => {
            BsyDialog({
              title: React.language('unbind'),
              height: 200,
              width: 460,
              okText: React.language("unbind.key"),
              cancelText: React.language("cancel"),
              onContentCreate: () => {
                return <div className={"unbindManagementContent"}>
                  <div className="lineMsg">
                    {React.language('unbind.management.msg')}
                  </div>
                </div>
              },
              onOk: () => {
                React.axios("/dashboard/standard_user_update", { _id: this.state.selectVal._id, data_id: t.data_id, unbind: true }).then((res) => {
                  if (res.data.code === 200) {
                    tipAlert({
                      type: "success",
                      msg: React.language("update.success")
                    })
                  }
                  this.loadData();
                })
              }
            })
          }
        },
        {
          text: React.language('data.operation.record'),
          click: () => {
            BsyAlertListDetail({
              type: "custom",
              width: 1000,
              createContent: (e) => {
                return <OperationRecord userManagementContext={this} projectId={this.state.projectId} data={t} selectVal={this.state.selectVal} onRemoveRoot={e.props && e.props.onRemoveRoot} />
              }
            })
          }
        }
      ]
      e.parentNode.classList.add("select");
      BsyAlertMenu({
        item: menu,
        width: "auto",
        target: event.target,
        customCls: "import-export-item",
        onClose: () => {
          e.parentNode.classList.remove("select")
        }
      })
    }
  }

  openDetail = (item) => {
    return (event) => {
      event.stopPropagation();
      BsyAlertListDetail({
        type: "custom",
        width: 1000,
        createContent: (e) => {
          return <UserViewDetailCont selectVal={this.state.selectVal} userManagementContext={this} projectId={this.state.selectVal._id} data={item} onRemoveRoot={e.props && e.props.onRemoveRoot} />
        }
      })
    }
  }

  render() {
    const { limit, skip, count, header, data, isLoading } = this.state;
    return <div className="UserManagement">
      <div className="ProjectTable">
        {isLoading && <BsySLoading style={{ background: '#ffffff' }} />}
        <div className="table-content">
          <div className="content-header">
            <div className="header-tr">
              {
                header.map(res => {
                  return <div className={`header-td ${res.id}`}>{res.name}</div>
                })
              }
            </div>
          </div>
          <div className="content-body">
            {
              data.map((res, key) => {
                return <div className={`body-tr ${key % 2 === 0 ? "" : "even"}`} onClick={this.openDetail(res)}>
                  <div className={`body-td operation`} onClick={this.openOperationMenu(res)}>
                    <i className="icon-flow-other"></i>
                  </div>
                  <div className={`body-td site`} title={res.sitedomain}><input type="text" value={res.sitedomain} readOnly={true} /></div>
                  <div className={`body-td account`}>{res.account}</div>
                  <div className={`body-td name`}>{res.username}</div>
                  <div className={`body-td expire`}>{res.expireTime ? BsyUtils.date2Str(dayjsUtils.timeToTZ(res.expireTime), "yyyy-MM-dd HH:mm:ss") : React.language("permanent")}</div>
                  <div className={`body-td version`}>{res.version}</div>
                  <div className={`body-td note`} title={res.remark} style={{ cursor: "pointer" }}>{res.remark}</div>
                  <div className={`body-td state state-${res.status}`}>{res.statusText}</div>
                </div>
              })
            }
          </div>
        </div>
      </div>
      <BsyTurnPage skipChange={this.skipChange} listLimitChange={this.listLimitChange} limit={limit} skip={skip}
        count={count} />
    </div>
  }
}

export default UserManagement;